var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('partner-message-table', {
    key: 'message-table',
    ref: "messageTable",
    attrs: {
      "refs": [_vm.ref],
      "store": _vm.store
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }